// extracted by mini-css-extract-plugin
module.exports = {"footBtn":"orderSubmit_footBtn__3-zGc"};